import { cookieHelper, largeExpirationCookieOpts } from './cookieHelper';

class CustomCookieStorage {
  getItem = (name: string): string | null | Promise<string | null> => {
    return cookieHelper.getCookie(name);
  };

  setItem = (name: string, value: string): void | Promise<void> => {
    cookieHelper.setCookie(name, value, largeExpirationCookieOpts.expires);
  };

  removeItem = (name: string): void | Promise<void> => {
    cookieHelper.eraseCookie(name);
  };
}

const customCookieStorage = new CustomCookieStorage();

export default customCookieStorage;
